import tw from 'tailwind-styled-components'

export const TwSettingsContainer = tw.div`
  pb-12
  px-16
`

type TwSettingsProps = {$hidden: boolean}
export const TwSettingsToggle = tw.div<TwSettingsProps>`
  ${(p): string => (p.$hidden ? 'invisible' : '')}
  text-12
  leading-4
  text-action-default
  cursor-pointer
  hover:text-action-hover
  active:text-action-pressed
`

export const TwSettingsContent = tw.div`
  flex
  flex-col
  items-start
  gap-8
`

export const TwSettingRow = tw.div`
  min-h-32
  flex
  flex-col
  items-start
  justify-center
  w-full
`

export const TwSetting = tw.div`
  w-full
  flex
  flex-col
`

export const TwCheckboxRow = tw.div`
  flex
  gap-8
  items-center
  py-8
`

export const TwSettingsHint = tw.div`
  text-third-old
  text-12
  leading-4
`
